module.exports = __webpack_public_path__ + "static/img/5.460f349.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/5.png
// module id = 4KJi
// module chunks = 0